module KendoWidgets
{
	export class PrintButton extends kendo.ui.Widget implements KendoWidget
	{

		protected _options: PrintButtonOptions;

		private _mappings: PrintButtonMapping[];

		private _cachedReportGuid: string | null = null;

		private _isRenderedAsButton: boolean;

		//#region Inner controls
		private _control: vr.Button | SplitButton;
		//#endregion

		controlType(): ControlTypeEnum { return ControlTypeEnum.PrintButton; }

		constructor(element: Element, options: PrintButtonOptions)
		{
			super(element, options);
			this._options = options;

			this.draw();
		}

		protected draw()
		{
			$(this.element).html("");
			$(this.element).css("vertical-align", "top");

			// Find out if we need to draw as a button or as a drop-down
			this.getMappings(mappings =>
			{
				this._mappings = mappings;

				if (mappings.length <= 1 && this._options.printMode != PrintButtonPreviewMode.Both)
					this.renderAsButton();
				else
					this.renderAsDropDown();
			});
		}

		private renderAsButton()
		{
			this._isRenderedAsButton = true;

			// Element is a div or a span. Anyways we will need to render into another tag inside of it.
			this._control = vr.createButton({ //< Button > $("<button class='k-print-button'>").appendTo(this.element).kendoButton(<ButtonOptions>{
				text: "Stampa",
				icon: vr.IconClassicLight.Print,
				onClick: _ => this.print(PrintButtonPreviewMode.DirectPrint, this._mappings[0].classPath),
				visible: this._options.visible ?? true,
				class: "k-print-button"

				//labelText: "Stampa",
				//icon: IconClass.Print,
				//click: _ => this.print(this._mappings[0].classPath),
				//visible: this._options.visible == null ? true : this._options.visible
			}, this.element); //.data("kendoButton");
		}

		private renderAsDropDown()
		{
			this._isRenderedAsButton = false;

			let items: SplitButtonItem[] = [];

			if (this._mappings.length > 1)
			{
				let item: SplitButtonItem = {
					text: "Stampa completa",
					icon: IconClass.Print,
					click: _ => this.print(PrintButtonPreviewMode.DirectPrint)
				};

				items.push(item);
			}

			//for (let mapping of this._mappings)
			for (let i = 0; i < this._mappings.length; i++)
			{
				let mapping = this._mappings[i];

				if (this._options.printMode != PrintButtonPreviewMode.Both)
				{
					let item: SplitButtonItem = {
						text: this._mappings.length > 1 ? mapping.name : "Stampa",
						icon: IconClass.Print,
						click: _ => this.print(this._options.printMode!, mapping.classPath),
						value: String(this._options.printMode)
					};

					items.push(item);
				}
				else
				{
					let item1: SplitButtonItem = {
						text: this._mappings.length > 1 ? mapping.name : "Stampa",
						icon: IconClass.Print,
						click: _ => this.print(PrintButtonPreviewMode.DirectPrint, mapping.classPath),
						value: String(PrintButtonPreviewMode.DirectPrint)
					};

					items.push(item1);


					let item2: SplitButtonItem = {
						text: this._mappings.length > 1 ? mapping.name + " (anteprima)" : "Stampa anteprima",
						icon: IconClass.Print,
						click: _ => this.print(PrintButtonPreviewMode.Preview, mapping.classPath),
						value: String(PrintButtonPreviewMode.Preview)
					};

					items.push(item2);
				}




			}

			// Element is a div or a span. Anyways we will need to render into another tag inside of it.
			let randId = Math.floor(Math.random() * 1000000);
			this._control = $("<div class='k-print-dropdown' id='spl" + randId.toString() + "'>").appendTo(this.element).kendoSplitButton(<SplitButtonOptions>{
				items: items,
				text: "Stampa",
				icon: IconClass.Print,
				visible: this._options.visible == null ? true : this._options.visible
			}).data("kendoSplitButton");
		}

		private getMappings(then: (mappings: PrintButtonMapping[]) => void)
		{
			let json = {
				AuthKey: "Bn_^BMEJQDyhj8-H",
				reportTypeId: this._options.reportTypeId,
				dynamicFieldSchemaId: this._options.dynamicFieldSchemaId,
				causalId: this._options.causalId,
			};

			let jsonS = JSON.stringify(json);

			$.ajax({
				async: false,
				beforeSend: (request) => request.setRequestHeader("Accept-Language", "it"),
				contentType: "application/json",
				data: jsonS,
				method: "POST",
				processData: false,
				url: "/api/PrintButtonWebApi/GetReportMappings",
				success: (response: any) =>
				{
					if (response.Success)
					{
						let mappings: PrintButtonMapping[] = response.mappings;
						then(mappings);
					}
					else
					{
						if (response.Exception.Code == "403")
						{
							location.replace("/");
							return;
						}

						alert("Impossibile ottenere le mappature collegate al tipo di report n. " + this._options.reportTypeId.toString() + ". Si è verificato un errore.");
					}
				},
				error: (response: JQueryXHR) =>
				{
					alert("Impossibile ottenere le mappature collegate al tipo di report n. " + this._options.reportTypeId.toString() + ". Si è verificato un errore.");
				}
			});
		}

		private print(printMode: PrintButtonPreviewMode, mapping?: string)
		{
			let mappings: string[];
			if (mapping == null)
				mappings = this._mappings.map(k => k.classPath);
			else mappings = [mapping];

			this._options.needDataSource(guid =>
			{
				if (this._options.refreshCache != null)
				{
					this._options.refreshCache((guid: string) =>
					{
						this._cachedReportGuid = guid;
						this.doPrint(guid, mappings, printMode);
					});
				}
				else this.doPrint(guid, mappings, printMode);
			});
		}

		public click()
		{
			if (this._isRenderedAsButton)
			{
				this.print(PrintButtonPreviewMode.DirectPrint, this._mappings[0].classPath);
			}
			else
			{
				this.print(PrintButtonPreviewMode.DirectPrint);
			}
		}

		private doPrint(guid: string, mappings: string[], printMode: PrintButtonPreviewMode)
		{
			let json = {
				AuthKey: "Bn_^BMEJQDyhj8-H",
				guid: guid,
				mappings: mappings,
				cachedReportGuid: this._cachedReportGuid
			};

			let jsonS = JSON.stringify(json);

			$.ajax({
				async: true,
				beforeSend: (request) => request.setRequestHeader("Accept-Language", "it"),
				contentType: "application/json",
				data: jsonS,
				method: "POST",
				processData: false,
				url: "/api/PrintButtonWebApi/Print",
				success: (response: any) =>
				{
					if (response.Success)
					{
						let bytes: string = response.bytes;
						this._options.readyPrint(bytes, printMode);
					}
					else
					{
						if (response.Exception.Code == "403")
						{
							location.replace("/");
							return;
						}

						alert("Impossibile stampare. Si è verificato un errore.");
					}
				},
				error: (response: JQueryXHR) =>
				{
					alert("Impossibile stampare. Si è verificato un errore.");
				}
			});
		}

		public visible(visible?: boolean): boolean
		{
			if (visible != null)
				this._control.visible(visible);
			return this._control.visible();
		}

		public changeSchema(schemaId: number, forceVisible?: boolean)
		{
			this._options.dynamicFieldSchemaId = schemaId;
			this.getMappings(m =>
			{
				let visible = forceVisible ?? this.visible();
				this._mappings = m;
				this.draw();
				setTimeout(() => this.visible(visible));
			});
		}

		public changeCausal(causalId: number)
		{
			this._options.causalId = causalId;
			this.getMappings(m =>
			{
				let visible = this.visible();
				this._mappings = m;
				this.draw();
				setTimeout(() => this.visible(visible));
			});
		}

		public changeCachedReport(guid: string | null)
		{
			this._cachedReportGuid = guid;
		}
	}

	export class PrintButtonOptions
	{
		reportTypeId: number;
		needDataSource: (callback: (guid: string) => void) => void;
		readyPrint: (bytes: string, printMode: PrintButtonPreviewMode) => void;
		visible?: boolean;

		dynamicFieldSchemaId?: number;
		causalId?: number;
		printMode?: PrintButtonPreviewMode = PrintButtonPreviewMode.DirectPrint;


		refreshCache?: (callback: (guid: string) => void) => void;
	}

	export enum PrintButtonPreviewMode
	{
		DirectPrint = 1,
		Preview = 2,
		Both = 3
	}

	class PrintButtonMapping
	{
		classPath: string;
		name: string;
	}

	PrintButton.fn = PrintButton.prototype;
	PrintButton.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	PrintButton.fn.options.name = "PrintButton";
	kendo.ui.plugin(PrintButton);
}

interface JQuery
{
	kendoPrintButton(options?: KendoWidgets.PrintButtonOptions): JQuery;
	data(key: "kendoPrintButton"): KendoWidgets.PrintButton;
}